import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=ed74db32"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=ed74db32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports